import { useLocation } from "react-router-dom";

export const useQuery = () => new URLSearchParams(useLocation().search);

export const setQuery = (text, value) => {
    const url = new URL(window.location.href)
    url.searchParams.set(text, value)
    window.history.replaceState(null, null, url)
}